module.exports = __webpack_public_path__ + "img/audition-unselect.69147fb4.png";